import React, { ReactNode, useEffect } from 'react';

import { useSelector } from '@tmapy/redux';
import type { LayerState, MapState } from '@tmapy/beetlejuice-utils';
import { MapProvider, MapView, Layer, actionSetMapState } from '@tmapy/mapcore';

import { actionSetMapDefaultState, MapActions } from '../actions';

type MapWithStoreProps = {
  state: MapState;
  dispatch: (action: MapActions) => void;
  children: ReactNode;
};

export const MapWithStore: React.FC<MapWithStoreProps> = ({ children, ...props }) => {
  const mapCore = useSelector((state) => state.mapCore);
  const providerProps = { ...mapCore.view, ...props };

  // When the component goes to be unmounted
  useEffect(() => {
    props.dispatch?.(actionSetMapState(props.state));

    return () => {
      // clear state
      props.dispatch?.(actionSetMapDefaultState());
    };
  }, []);

  return (
    <MapProvider {...providerProps}>
      <MapView />
      {mapCore.layers.map((layer: LayerState) => (
        <Layer key={layer.id} {...layer} dispatch={props.dispatch} />
      ))}
      {children}
    </MapProvider>
  );
};
